'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AthletesNoble = undefined;
exports.getAthlete = getAthlete;
exports.getSummary = getSummary;
exports.getProfileCallback = getProfileCallback;
exports.getProfile = getProfile;
exports.addFriend = addFriend;
exports.removeFriend = removeFriend;
exports.getFriends = getFriends;
exports.heartResult = heartResult;
exports.unheartResult = unheartResult;
exports.isResultHearted = isResultHearted;
exports.claimResult = claimResult;

var _rx = require('rx');

var _bastetjs = require('bastetjs');

var _FetchPeon = require('../peons/FetchPeon');

var _Configure = require('../Configure');

var _RetryHelper = require('./helpers/RetryHelper');

/**
 * @param {int} racerId
 * @param {object|null} Optional timeoutOpts.
 * @see FetchPeon.doFetch.
 * @return Observable
 */
function getAthlete(_ref) {
  var racerId = _ref.racerId;
  var timeoutOpts = _ref.timeoutOpts;

  var host = (0, _Configure.getValue)('ATHLINKS_API_HOST');
  return (0, _FetchPeon.doFetch)(host + '/Athletes/Api/' + racerId, null, true, timeoutOpts);
}

/**
 * @param {int} racerId
 * @param {object|null} Optional timeoutOpts.
 * @see FetchPeon.doFetch.
 * @return Observable
 */
function getSummary(_ref2) {
  var racerId = _ref2.racerId;
  var timeoutOpts = _ref2.timeoutOpts;

  var host = (0, _Configure.getValue)('ATHLINKS_API_HOST');
  return (0, _FetchPeon.doFetch)(host + '/Athletes/Api/' + racerId + '/Summary', null, true, timeoutOpts);
}

function getProfileCallback(_ref3) {
  var racerId = _ref3.racerId;
  var timeoutOpts = _ref3.timeoutOpts;

  var athlete = getAthlete({ racerId: racerId, timeoutOpts: timeoutOpts });
  var summary = getSummary({ racerId: racerId, timeoutOpts: timeoutOpts });

  return _rx.Observable.combineLatest(athlete, summary).map(function (combined) {
    function athleteRes(key, def) {
      return combined[0].Result ? combined[0].Result[key] : def;
    }
    function picRes(key, def) {
      return combined[0].Result ? combined[0].Result.LogoUrls[key] : def;
    }
    function summaryRes(key, def) {
      return combined[1].Result ? combined[1].Result.resultsSummary[key] : def;
    }

    return _bastetjs.utils.entityDecoder.decode({
      displayName: athleteRes('DisplayName', ''),
      gender: athleteRes('Gender', ''),
      age: athleteRes('Age', ''),
      city: athleteRes('City', ''),
      state: athleteRes('StateProvName', ''),
      country: athleteRes('CountryID3', ''),
      profilePic: {
        hasImage: picRes('HasImage', false),
        thumb: picRes('Thumb', null),
        small: picRes('Small', null),
        medium: picRes('Medium', null),
        large: picRes('Large', null),
        xl: picRes('Xl', null)
      },
      milesRaced: summaryRes('MilesRaced', 0),
      totalRaces: summaryRes('TotalRaces', 0),
      isLoading: false
    });
  });
}

function getProfile(_ref4) {
  var racerId = _ref4.racerId;
  var timeoutOpts = _ref4.timeoutOpts;

  return (0, _RetryHelper.retryHelper)('profile', getProfileCallback, { racerId: racerId, timeoutOpts: timeoutOpts });
}

function callApi(path, method, headers, body) {
  var url = (0, _Configure.getValue)('ATHLINKS_API_HOST') + ('/' + path);
  var req = {
    method: method,
    headers: Object.assign({}, headers || {}, {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + (0, _Configure.getConfigs)().access_token,
      'Content-type': 'application/json'
    })
  };
  var reqWithBody = body ? Object.assign(req, { body: body }) : req;
  return (0, _FetchPeon.doFetch)(url, reqWithBody);
}
function addFriend(_ref5) {
  var racerId = _ref5.racerId;

  return callApi('Links/Api/Follow/' + racerId, 'post');
}

function removeFriend(_ref6) {
  var racerId = _ref6.racerId;

  return callApi('Links/Api/Unfollow/' + racerId, 'delete');
}

function getFriends() {
  return callApi('Links/Api/Friends', 'get');
}

function heartResult(_ref7) {
  var racerId = _ref7.racerId;
  var eventId = _ref7.eventId;
  var courseId = _ref7.courseId;
  var resultEntryId = _ref7.resultEntryId;

  var path = 'Athletes/Api/' + racerId + '/Races/' + eventId + '/Cheer';
  var headers = { 'Content-type': 'application/json;charset=UTF-8' };
  var body = JSON.stringify({ courseId: courseId, resultEntryId: resultEntryId });
  return callApi(path, 'post', headers, body);
}

function unheartResult(_ref8) {
  var racerId = _ref8.racerId;
  var eventId = _ref8.eventId;
  var courseId = _ref8.courseId;
  var resultEntryId = _ref8.resultEntryId;

  var path = 'Athletes/Api/' + racerId + '/Races/' + eventId + '/Uncheer';
  var headers = { 'Content-type': 'application/json;charset=UTF-8' };
  var body = JSON.stringify({ courseId: courseId, resultEntryId: resultEntryId });
  return callApi(path, 'delete', headers, body);
}

function isResultHearted(_ref9) {
  var racerId = _ref9.racerId;
  var eventId = _ref9.eventId;
  var courseId = _ref9.courseId;
  var resultEntryId = _ref9.resultEntryId;
  var gender = _ref9.gender;

  var path = 'Athletes/Api/' + racerId + '/Races/' + resultEntryId + '/Social' + ('?eventId=' + eventId + '&courseId=' + courseId + '&gender=' + gender + '&classId=7');
  return callApi(path, 'get');
}

function claimResult(_ref10) {
  var entryId = _ref10.entryId;
  var isMergeRequest = _ref10.isMergeRequest;

  var path = 'Claim/Api/Entries';
  var body = '{"entryIds": [' + entryId + '], "isMergeRequest": ' + isMergeRequest + '}';
  return callApi(path, 'post', {}, body);
}

// For testing
var AthletesNoble = exports.AthletesNoble = {
  heartResult: heartResult,
  unheartResult: unheartResult,
  isResultHearted: isResultHearted,
  getAthlete: getAthlete,
  getSummary: getSummary,
  getProfile: getProfile,
  getProfileCallback: getProfileCallback,
  addFriend: addFriend,
  removeFriend: removeFriend,
  getFriends: getFriends,
  claimResult: claimResult
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/AthletesNoble.js
// module id = 422
// module chunks = 0